import { useActionState } from "react";
import { updateTopicAction } from "@/actions/topics";
import { Button } from "@/components/Button";
import { FormCell, StaticCell } from "@/components/FormCell";
import styles from "@/components/FormRow.module.css";
import { LinkButton } from "@/components/LinkButton";
import { initialFormState } from "@/lib/formState";
import { useFormRedirect } from "@/lib/useFormRedirect";

const FORM_ID = "topic-edit";

type TopicEditRowProps = {
  // The listing owns the rows, so a save has to tell it to read again.
  onSaved: () => void;
  id: number;
  code: string;
  label: string | null;
  icon: string | null;
  sortOrder: number;
};

export const TopicEditRow = ({
 onSaved,
  id,
  code,
  label,
  icon,
  sortOrder,
}: TopicEditRowProps) => {
  const [state, formAction, isPending] = useActionState(
    updateTopicAction.bind(null, id),
    initialFormState,
  );

  useFormRedirect(state, onSaved);

  return (
    <>
      <StaticCell value={code} isRowHeader />
      <FormCell
        form={FORM_ID}
        name="label"
        label="Label"
        defaultValue={state.values.label ?? label ?? ""}
        errors={state.fieldErrors.label}
      />
      <FormCell
        form={FORM_ID}
        name="icon"
        label="Icon"
        defaultValue={state.values.icon ?? icon ?? ""}
        errors={state.fieldErrors.icon}
      />
      <FormCell
        form={FORM_ID}
        name="sortOrder"
        label="Sort order"
        inputMode="numeric"
        defaultValue={state.values.sortOrder ?? String(sortOrder)}
        errors={state.fieldErrors.sortOrder}
      />
      {/* State and the actions column: read-only while editing. */}
      <td className={styles.actions} colSpan={2}>
        {/* A form may not be a child of tbody, but it may sit inside a cell —
            the inputs above associate to it by id. */}
        <form id={FORM_ID} action={formAction} hidden />
        <Button
          type="submit"
          form={FORM_ID}
          variant="primary"
          disabled={isPending}
        >
          {isPending ? "Saving..." : "Save"}
        </Button>
        <LinkButton href="/topics" variant="secondary" shouldReplaceHistory>
          Cancel
        </LinkButton>
      </td>
    </>
  );
};
